import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import authorize from '../../utils/auth';
import AuthorizedResource from '../authorization/AuthorizedResource';
import COMPANY_PERMISSIONS_CONTROLLER, { COMPANY_PERMISSIONS_TOAST_SCOPE } from '../../controllers/companyPermissions';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import NoData from '../page/NoData';
import CompanyPermissionsTable from './CompanyPermissionsTable';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import ApplicationToast from '../inAppMessages/ApplicationToast';
import { toastActions } from '../inAppMessages/toastActions';
import Logger, { ALL_MESSAGES, LOG_LEVELS } from '../../utils/logger';

const FORM_NAME = "COMPANY_PERMISSIONS_PAGE";
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

export const CompanyPermissionsPage = (props) => {
    const [toggleFilterPanel, setToggleFilterPanel] = useState(true);

    const allCompanyOptions = props.allCompanies?.map((company) => {
        return {
            label: `${company.code} - ${company.name}`,
            value: company.id.toString()
        };
    });

    useEffect(() => {
        props.onPageLoad(props.tenantId, props.iamTenantId, () => {
            log.setDictionaryMessage(ALL_MESSAGES.COMPANY_PERMISSION_LOAD_ERROR);
        });
        
        return () => {
            log.clearAllDictionaryErrors();
        }
    }, []);

    const handleToggleFilterPanel = () => {
        setToggleFilterPanel(!toggleFilterPanel);
    }

    return (
        <div className="content-area" data-testid="company-permissions-page">
            <s-container>
                <h1><LanguageStringResolver string='CompanyPermissions_Title' /></h1>
                <p><LanguageStringResolver string='CompanyPermissions_PageDescription' /></p>
                <ApplicationMessages messageType="applicationError" messageIds={[ALL_MESSAGES.COMPANY_PERMISSION_LOAD_ERROR]} />
                <s-row>
                    <s-col span="6">
                        <button
                            className={toggleFilterPanel ? "toggle-button icon-leading mt10" : "secondary icon-leading mt10"}
                            data-testid="filter-button"
                            onClick={handleToggleFilterPanel}
                        >
                            <s-icon name="filter" />
                            <LanguageStringResolver string='FilterButton' />
                        </button>
                    </s-col>
                </s-row>
                {
                    (props.users && props.users.length) > 0 ?
                        <CompanyPermissionsTable
                            users={props.users}
                            companiesLookup={props.companiesLookup}
                            languages={props.languages}
                            toggleFilterPanel={toggleFilterPanel}
                            setToggleFilterPanel={setToggleFilterPanel}
                            allCompanyOptions={allCompanyOptions}
                        />
                        :
                        <NoData noDataText="users_NoData" />
                }
                <ApplicationToast
                    scope={COMPANY_PERMISSIONS_TOAST_SCOPE}
                    testId="company-permissions-toast"
                    showOnMount
                    onDismiss={props.onDismissToast}
                />
            </s-container>
        </div>
    );
};

export function mapStateToProps(state) {
    return {
        users: state.companyPermissions?.data,
        companiesLookup: state.companyPermissions?.companiesLookup,
        iamTenantId: state.authentication?.data?.iamData?.tenantId,
        error: (state.companyPermissions?.error),
        languages: state.languages,
        allCompanies: state.companyPermissions?.allCompanies,
        tenantId: state.authentication && state.authentication.data && state.authentication.data.customerId
    };
}

export function mapDispatchersToProps(dispatch) {
    return {
        onPageLoad: (tenantId, iamTenantId, errorHandler) => {
            dispatch(COMPANY_PERMISSIONS_CONTROLLER.doLoad(tenantId, iamTenantId, errorHandler));
            dispatch(COMPANY_PERMISSIONS_CONTROLLER.doLoadCompanies());
        },
        onDismissToast: (id) => {
            dispatch(toastActions.removeToast(id));
        }
    };
}

export default authorize({
    name: 'CompanyPermissions',
    resource: connect(mapStateToProps, mapDispatchersToProps)(CompanyPermissionsPage)
},
    AuthorizedResource, {
    showNotAuthorized: true
});